'use client'

import { Dialog } from '@vinted/web-ui'

import { TransactionSide } from '@marketplace-web/messaging/conversation-messaging-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

type Props = {
  isOpen: boolean
  userSide?: TransactionSide | null
  onSubmit: () => void
  onClose: () => void
}

const ConfirmEverythingIsOkModal = ({ isOpen, userSide, onSubmit, onClose }: Props) => {
  const isBuyer = userSide === TransactionSide.Buyer
  const translationPrefix = isBuyer
    ? 'conversation.confirm_everything_is_ok_modal'
    : 'conversation.confirm_everything_is_ok_modal.seller'

  const translate = useTranslate(translationPrefix)

  return (
    <Dialog
      title={translate('title')}
      body={translate('body')}
      testId="confirm-everything-is-ok-modal"
      actions={[
        {
          text: translate('actions.confirm'),
          style: Dialog.ActionStyling.Filled,
          callback: onSubmit,
          testId: 'confirm-everything-is-ok-modal--confirm-button',
        },
        {
          text: translate('actions.close'),
          style: Dialog.ActionStyling.Flat,
          callback: onClose,
          testId: 'confirm-everything-is-ok-modal--close-button',
        },
      ]}
      show={isOpen}
    />
  )
}

export default ConfirmEverythingIsOkModal
